import React, { useState, useEffect } from 'react';
import { Navigate, useParams, useNavigate } from "react-router-dom";
import ScreenHeader from '../../components/ScreenHeader';
import ApprovalList from './ApprovalList';
import ApprovedVisitorsList from './ApprovedVisitorsList';
import useSWR from 'swr';
import { localAxios } from '../../api';

export function loader() {
  return "Approve default data goes here.";
}

function Approve() {

  const params = useParams();

  const { data: locationsData, isLoading: locationsLoading } = useSWR('/api/locations', localAxios);
  const locations = locationsData?.data ?? [];
  const matchedLocation = locations.find(l => l.location_name === params.siteName);
  const siteID = matchedLocation?.id;
  const siteName = matchedLocation?.location_name ?? params.siteName;

  const { data, error, isValidating } = useSWR(!locationsLoading ? `/api/approve?siteID=${siteID}` : null, localAxios);
  const { data: data2 } = useSWR(!locationsLoading ? `/api/approved?siteID=${siteID}` : null, localAxios);

  const navigate = useNavigate();

  const approvals = data?.data.approvals;
  const approvedVs = data2?.data.approvedVs;

  const [checkedIds, setCheckedIds] = useState({});
  const [selectAll, setSelectAll] = useState(false);
  const [agreeChecked, setAgreeChecked] = useState(false);

  useEffect(() => {
    setCheckedIds({});
    setSelectAll(false);
  }, [approvals]);

  useEffect(() => {
    if (siteID) {
      localAxios.post('/api/workflow-state', { step: 'approve', site_id: siteID })
        .catch((err) => console.log('Error saving workflow state:', err));
    }
  }, [siteID]);

  const approvedCount = approvals ? approvals.filter(a => checkedIds[a.id]).length : 0;
  const canSubmit = approvedCount > 0 && agreeChecked;

  const handleToggle = (id) => {
    setCheckedIds(prev => ({ ...prev, [id]: !prev[id] }));
  };

  const handleToggleAll = () => {
    const next = !selectAll;
    setSelectAll(next);
    setCheckedIds(next ? Object.fromEntries(approvals.map(a => [a.id, true])) : {});
  };

  const postData = () => {
    const now = new Date();

    const updated = approvals.map(a => checkedIds[a.id]
      ? { ...a, approve_datetime: now.toISOString(), approver_email: data?.data.email, approve_flag: 1 }
      : a
    );

    const formDataObj = {
      example: JSON.stringify(updated),
      siteID: siteID.toString(),
    };

    if (agreeChecked) {
      formDataObj.approve_acknowledge_flag = "1";
    }

    return localAxios.post('/api/approve', JSON.stringify(formDataObj)).then(response => {
      if (response) {
        navigate("/approved");
      }
    }).catch((error) => {
      console.log(error);
    });
  };

  if (locationsLoading || (!data && isValidating)) {
    return (
      <div className="app-wide__container">
        <ScreenHeader message="Visitor Training Tracker" />
        <div className="app-wide__add-new" />
        <div className="app-wide__main" style={{ padding: '24px 16px', textAlign: 'center' }}>
          <p>Loading...</p>
        </div>
        <div className="app-wide__footer" />
      </div>
    );
  }

  if (data && !isValidating) {

    return (
      <div
        className="app-wide__container"
        style={{ height: 'calc(100vh - 2rem)', gridTemplateRows: '60px auto 1fr 70px' }}
      >
        <ScreenHeader message="Visitor Training Tracker" />

        <div className="app-wide__add-new approve__site-info">
          <h2 className="approve__site-name">{siteName}</h2>
          <p className="approve__visit-count">
            {approvals && approvals.length > 0
              ? <>You have <b>{approvals.length}</b> visitor{approvals.length > 1 ? 's' : ''} to approve.</>
              : 'No visitors to approve at this time.'}
          </p>
        </div>

        <div className="app-wide__main approve__main" style={{ overflow: 'hidden' }}>
          {approvals && (
            <section className="approve__section">
              <h3 className="approve__section-title">Visitors Awaiting Approval</h3>
              <ApprovalList
                approvals={approvals}
                checkedIds={checkedIds}
                selectAll={selectAll}
                onToggle={handleToggle}
                onToggleAll={handleToggleAll}
              />
              {approvals.length > 0 && (
                <label className="approve__agree-label">
                  I Agree:{' '}
                  <input
                    type="checkbox"
                    checked={agreeChecked}
                    onChange={(e) => setAgreeChecked(e.target.checked)}
                  />
                </label>
              )}
            </section>
          )}

          <section className="approve__section approve__section--fill">
            <h3 className="approve__section-title">Previously Approved</h3>
            <ApprovedVisitorsList approvedVs={approvedVs} />
          </section>
        </div>

        <div className="app-wide__footer">
          {approvals && approvals.length > 0 && (
            <div className="formButtons">
              <button
                type="button"
                className="button save"
                disabled={!canSubmit}
                onClick={postData}
              >
                Submit
              </button>
            </div>
          )}
        </div>
      </div>
    );

  }

  if (isValidating) {
    return (
      <div className="app-wide__container">
        <ScreenHeader message="Visitor Training Tracker" />
        <div className="app-wide__add-new" />
        <div className="app-wide__main" style={{ padding: '24px 16px', textAlign: 'center' }}>
          <p>Validating data...</p>
        </div>
        <div className="app-wide__footer" />
      </div>
    );
  }

  if (!data?.data.loggedIn) {
    return <Navigate to="/login" />;
  }

  if (error) {
    return (
      <div className="app-wide__container">
        <ScreenHeader message="Visitor Training Tracker" />
        <div className="app-wide__add-new" />
        <div className="app-wide__main" style={{ padding: '24px 16px', textAlign: 'center' }}>
          <p>Error: {error.message}</p>
        </div>
        <div className="app-wide__footer" />
      </div>
    );
  }

} // function

export default Approve;
